import classNames from 'classnames';
import classes from './Tab.module.scss';
import { forwardRef } from 'react';

const AppTabContainer = forwardRef(({ className, children, isAttached, ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={classNames(
                classes.tabContainer,
                !isAttached && classes.tabContainerSeparate,
                isAttached && classes.tabContainerAttached,
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
});
export default AppTabContainer;
